import { Link, useLocation } from "react-router-dom";
import PropTypes from 'prop-types';

const formatSegment = (segment) => {
    if (!segment) return segment;
    return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
};

const Breadcrumbs = ({ className }) => {
    const location = useLocation();
    const crumbs = location.pathname.split('/');

    if (crumbs.length <= 1) {
        return null;
    }

    return (
        <div className={`${className || ''} py-2`}>
            <div>
                {crumbs?.map((name, key) => {
                    const path = location.pathname.split('/', key + 1).join('/') || '/';
                    return key + 1 === crumbs.length ? (
                        <span key={path} className="text-gray-500 text-sm capitalize">
                            {location?.state?.name ? location?.state?.name : formatSegment(name)}
                        </span>
                    ) : (
                        <Link key={path} to={path}>
                            {key === 0 ?
                                <div className="hover:text-blue-500 font-medium inline-flex items-center">
                                    &nbsp;
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                    </svg>
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                                :
                                <span className="hover:text-blue-500 text-sm font-medium inline-flex items-center capitalize">
                                    {formatSegment(name)}
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </span>
                            }
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

Breadcrumbs.propTypes = {
  className: PropTypes.string,
};

export default Breadcrumbs;
